var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, debounce, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Add01Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useGetClientsListQuery } from '../../../application/features/clients/client-api';
import { useLazyGetLocationQuery, useLazySearchCityLocationQuery } from '../../../application/features/pdok/pdok-api';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import FilterButton from '../../components/FilterButton';
import PageHeaderButton from '../../components/PageHeaderButton';
import ProtectedElement from '../../components/ProtectedElement';
import { Permissions } from '../../permissions';
import AddClient from './add-client';
import ClientCards from './client-cards';
import ClientsDesktop from './clients-desktop';
import ClientDetail from './clients-detail';
import DeleteClient from './delete-client';
import EditClient from './edit-client';
var Clients = function () {
    var theme = useTheme();
    var _a = useTranslate(), translate = _a.translate, tWithFunction = _a.tWithFunction;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isscreen9001200Landscape = useMediaQuery('(min-width:900px) and (max-width:1200px) and (orientation: landscape)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var geoControlRef = useRef(null);
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var _b = __read(useState(), 2), userLocation = _b[0], setUserLocation = _b[1];
    var _c = __read(useState({
        clients: [],
        locations: []
    }), 2), clientFilters = _c[0], setClientFilters = _c[1];
    var _d = __read(useState(false), 2), clientDetailsDrawerOpen = _d[0], setClientDetailsDrawerOpen = _d[1];
    var _e = __read(useState(false), 2), mapDrawerOpen = _e[0], setMapDrawerOpen = _e[1];
    var _f = __read(useState(undefined), 2), clientToShowOnMap = _f[0], setClientToShowOnMap = _f[1];
    var _g = __read(useState(), 2), selectedClientName = _g[0], setSelectedClientName = _g[1];
    var _h = __read(useState(), 2), selectedClientId = _h[0], setSelectedClientId = _h[1];
    var _j = __read(useState(false), 2), editClientModalOpen = _j[0], setEditClientModalOpen = _j[1];
    var _k = __read(useState(false), 2), deleteClientModalOpen = _k[0], setDeleteClientModalOpen = _k[1];
    var _l = __read(useState(false), 2), addClientsModalOpen = _l[0], setAddClientsModalOpen = _l[1];
    var _m = __read(useState(''), 2), locationSearchTerm = _m[0], setLocationSearchTerm = _m[1];
    var _o = __read(useLazyGetLocationQuery(), 1), triggerGetLocation = _o[0];
    var _p = __read(useState(false), 2), openFilterDrawer = _p[0], setOpenFilterDrawer = _p[1];
    var _q = __read(useState(0), 2), clientsCount = _q[0], setClientsCount = _q[1];
    var _r = __read(useState('grid'), 2), viewMode = _r[0], setViewMode = _r[1];
    var _s = useGetClientsListQuery(), _t = _s.data, clientsList = _t === void 0 ? [] : _t, isClientsListFetching = _s.isFetching;
    var _u = __read(useLazySearchCityLocationQuery(), 2), triggerSearchLocation = _u[0], _v = _u[1], _w = _v.data, locations = _w === void 0 ? [] : _w, isLocationsFetching = _v.isFetching;
    var _x = useForm({
        defaultValues: {
            clients: [],
            locations: []
        }
    }), control = _x.control, handleSubmit = _x.handleSubmit, setValue = _x.setValue, reset = _x.reset;
    var getSearchResults = useMemo(function () {
        return debounce(function (searchTerm) {
            if (searchTerm)
                triggerSearchLocation(searchTerm);
        }, 1000);
    }, [triggerSearchLocation]);
    useEffect(function () {
        getSearchResults(locationSearchTerm);
    }, [getSearchResults, locationSearchTerm]);
    useEffect(function () {
        if (!userLocation)
            getLocation();
    }, [userLocation]);
    var onLocationChange = function (locations) { return __awaiter(void 0, void 0, void 0, function () {
        var searchedLocations, locationPromises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchedLocations = [];
                    locationPromises = locations.map(function (location) { return __awaiter(void 0, void 0, void 0, function () {
                        var details;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, triggerGetLocation(location.id).unwrap()];
                                case 1:
                                    details = _a.sent();
                                    if (details) {
                                        searchedLocations.push(details.woonplaatsnaam);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(locationPromises)];
                case 1:
                    _a.sent();
                    setValue('locations', searchedLocations);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (currentCompany) {
            setClientFilters({
                locations: [],
                clients: []
            });
            reset();
            resetLocation();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCompany]);
    var resetLocation = function () {
        setValue('locations', []);
    };
    var filterClients = function (filters) {
        setClientFilters({
            clients: filters.clients,
            locations: filters.locations
        });
    };
    var onClientClick = function (clientId) {
        setSelectedClientId(clientId);
        setClientDetailsDrawerOpen(true);
    };
    var handleOpenAddClients = function () {
        setAddClientsModalOpen(true);
    };
    var handleEditClient = function (clientId) {
        setSelectedClientId(clientId);
        setEditClientModalOpen(true);
    };
    var handleDeleteClient = function (client) {
        setSelectedClientId(client.id);
        setSelectedClientName(client.name);
        setDeleteClientModalOpen(true);
    };
    var handleCloseEditClientModal = function () {
        setEditClientModalOpen(false);
    };
    var handleCloseDeleteClientModal = function () {
        setDeleteClientModalOpen(false);
        setSelectedClientName(undefined);
    };
    var onShowOnMap = function (client) {
        setClientToShowOnMap(client);
        setMapDrawerOpen(true);
    };
    var handleCloseMapDrawer = function () {
        setMapDrawerOpen(false);
        setClientToShowOnMap(undefined);
    };
    var handleFilterClick = function () {
        setOpenFilterDrawer(function (prev) { return !prev; });
    };
    var getLocation = function () {
        navigator.geolocation.getCurrentPosition(function (position) {
            setTimeout(function () {
                var _a;
                (_a = geoControlRef.current) === null || _a === void 0 ? void 0 : _a.trigger();
                setUserLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            }, 500);
        });
    };
    var navigate = function (clientData) {
        if (userLocation && clientData) {
            var baseUrl = 'https://www.google.com/maps/dir/?api=1';
            var origin_1 = "&origin=".concat(userLocation.latitude, ",").concat(userLocation.longitude);
            var dest = "&destination=".concat(clientData.latitude, ",").concat(clientData.longitude);
            var travelMode = '&travelmode=driving';
            var url = "".concat(baseUrl).concat(origin_1).concat(dest).concat(travelMode);
            window.open(url, '_blank');
        }
    };
    var onGetDirections = function (client) {
        if (client === void 0) { client = null; }
        var clientData = client;
        if (clientData)
            navigate(clientData);
        if (!userLocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setUserLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
                navigate(clientData);
            }, function (error) {
                if (error.code === error.PERMISSION_DENIED) {
                    enqueueSnackbar(translate('validations.locationAccessError'), {
                        autoHideDuration: 3000,
                        variant: 'error',
                        anchorOrigin: { horizontal: 'right', vertical: 'top' }
                    });
                }
                else {
                    enqueueSnackbar(translate('validations.locationError'), {
                        autoHideDuration: 3000,
                        variant: 'error',
                        anchorOrigin: { horizontal: 'right', vertical: 'top' }
                    });
                }
            });
        }
    };
    var onViewModeChanged = function (viewMode) { return viewMode && setViewMode(viewMode); };
    return (_jsxs(Box, { sx: {
            width: '100%',
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, justifyContent: isXs || isscreen600900 || iscreen9001200 || isIpadMiniLandscape ? 'space-between' : '', mb: { xs: 1, md: 2 }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.clients') }), _jsx(ProtectedElement, { permissions: [Permissions.Clients.Create], children: _jsx(PageHeaderButton, { text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: handleOpenAddClients, variant: 'contained', color: 'primary', title: tWithFunction('actions.addFunction', 'common.client') }) })] }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick }))] }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(ClientCards, { control: control, handleSubmit: handleSubmit, reset: reset, clientsList: clientsList, locations: locations, filterClients: filterClients, isClientsListFetching: isClientsListFetching, isLocationsFetching: isLocationsFetching, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, clientFilters: clientFilters, onLocationChange: onLocationChange, locationSearchTerm: locationSearchTerm, setLocationSearchTerm: setLocationSearchTerm, viewMode: viewMode, onViewModeChanged: onViewModeChanged, clientsCount: clientsCount, setClientsCount: setClientsCount, onClientClick: onClientClick, onGetDirections: onGetDirections, handleEditClient: handleEditClient, handleDeleteClient: handleDeleteClient, onShowOnMap: onShowOnMap, mapDrawerOpen: mapDrawerOpen, handleCloseMapDrawer: handleCloseMapDrawer, clientToShowOnMap: clientToShowOnMap, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isXs: isXs, isIpadMiniLandscape: isIpadMiniLandscape, isscreen9001200Landscape: isscreen9001200Landscape })) : (_jsx(ClientsDesktop, { control: control, reset: reset, handleSubmit: handleSubmit, clientsList: clientsList, locations: locations, isClientsListFetching: isClientsListFetching, isLocationsFetching: isLocationsFetching, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, clientFilters: clientFilters, onLocationChange: onLocationChange, locationSearchTerm: locationSearchTerm, setLocationSearchTerm: setLocationSearchTerm, filterClients: filterClients, viewMode: viewMode, onViewModeChanged: onViewModeChanged, clientsCount: clientsCount, setClientsCount: setClientsCount, onClientClick: onClientClick, onGetDirections: onGetDirections, handleEditClient: handleEditClient, handleDeleteClient: handleDeleteClient, onShowOnMap: onShowOnMap, mapDrawerOpen: mapDrawerOpen, handleCloseMapDrawer: handleCloseMapDrawer, clientToShowOnMap: clientToShowOnMap, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isXs: isXs, isIpadMiniLandscape: isIpadMiniLandscape, isscreen9001200Landscape: isscreen9001200Landscape })), selectedClientId && clientDetailsDrawerOpen && (_jsx(ClientDetail, { isOpen: clientDetailsDrawerOpen, setIsOpen: setClientDetailsDrawerOpen, clientId: selectedClientId, onGetDirections: onGetDirections })), editClientModalOpen && selectedClientId && (_jsx(EditClient, { open: editClientModalOpen, clientId: selectedClientId, onClose: handleCloseEditClientModal })), deleteClientModalOpen && selectedClientId && selectedClientName && (_jsx(DeleteClient, { open: deleteClientModalOpen, onClose: handleCloseDeleteClientModal, clientId: selectedClientId, clientName: selectedClientName })), addClientsModalOpen && (_jsx(AddClient, { onClose: function () { return setAddClientsModalOpen(false); }, open: addClientsModalOpen }))] }));
};
export default Clients;
